import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../global';
import { Router, Params, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ReturnStatement } from '@angular/compiler';
import { Observable, from, of } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import * as moment from 'moment-timezone';

//max time for api requests
const MAX_TIME = 60000;
const TOKEN_KEY = 'token';
const REFRESHTOKEN_KEY = 'refresh';
const PERMISSIONS_KEY = 'permissions';
const TOKEN_EXPIRE_KEY = '';
const TOKEN_EXPIRES_PERIOD = 20;

@Injectable({
  providedIn: 'root'
})

export class LoginService implements CanActivate {

  private url: any;
  private token: any;
  public cont: number;
  momentjs: any = moment;

  pages = [
      {id: 'admins', name: "ADMIN"},
      {id: 'users', name: "ADMIN-CRUD-USER"},
      {id: 'roles', name: "ADMIN-CRUD-ROLE"},
      {id: 'clients', name: "ADMIN-CRUD-ROLE"},
      {id: 'sysparams', name: "ADMIN-CRUD-SYSPARAMS"},
      {id: 'sales', name: "ADMIN-SALES"},
      {id: 'sales-info-files', name: "ADMIN-SALES-INFO_FILES"},
      {id: 'sales-agents', name: "ADMIN-SALES-AGENTS"},
      {id: 'sales-agent-backup', name: "ADMIN-SALES-AGENTS_BACKUP"},
      {id: 'agent-management-report', name: "ADMIN-SALES-REPORTS-AGENT_MANAGEMENT"},
      {id: 'order-followup-report', name: "ADMIN-SALES-REPORTS-ORDER_FOLLOW"},
      {id: 'version-report', name: "ADMIN-SALES-REPORTS-VERSION_AGENT"},
      {id: 'sync-audit-report', name: "ADMIN-SALES-REPORTS-SYNC_AUDIT"},
      {id: 'order-approvers', name: "ADMIN-SALES-ORDER_APPROVERS"}
    ];

  constructor(
    private _router: Router,
    private _http: HttpClient,
    private storage: Storage,
    private route: ActivatedRoute
  ) {
      this.url = Global.url;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      var page = state.url;

      return this.storage.get('token').then(t => {
          if( (t != undefined) && (t != '') ){
              return true;
          }
          else{
            this._router.navigate(['/authentication/login']);
            return false;
          }
      });

      /*return this.storage.get(PERMISSIONS_KEY).then(mods => {
            let permissions = ['dashboard', 'settings', 'home', 'collaborators'];
            let ipage:any;
            //console.log('inside permissions check');
            //return true;

            if( !Array.isArray(mods) ){
                this.clearData().then(() => {
                    this._router.navigate(['/authentication/login']);
                });
                return false;
            }

            mods.forEach(i => {
                ipage = this.getPageIdFromModule(i);
                if( ipage != false ){
                    permissions.push(ipage);
                }
            });

            //console.log(page);
            //console.log(permissions);
            page = page.replace("/", "");

            let checker = permissions.filter(p => {
                  //return page.toLowerCase().includes(p.toLowerCase());
                  return page.toLowerCase() == p.toLowerCase();
            });

            //console.log(checker);

            if( checker.length > 0 ){
                return true;
            }
            else{
                this._router.navigate(['/home']);
                return false;
            }
      });*/
  }

  getPageIdFromModule(md){
      let tmp = [];
      tmp = this.pages.filter(function(a){
                        return a.name == md;
                      });

      if( tmp.length > 0 ){
          return tmp[0].id;
      }

      return false;
  }

  getPermissions(){
      return this.storage.get(PERMISSIONS_KEY);
  }

  public login(data: any) {
      const params = JSON.stringify(data);
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this._http.post(`${this.url}login`, params, { headers });
  }

  public saveData(data: any) {
      this.cont = 0;
      var subsidiary = ( (data['subsidiaryId'] == null) || (data['subsidiaryId'] == undefined) ) ? 0 : data['subsidiaryId'];
      
      var promises = [
          this.storage.set('userinfo', data['user']['name']),
          this.storage.set('token', data['token']),
          this.storage.set('subsidiaryId', subsidiary)
      ];

      return Promise.all(promises);
      //return this.storage.set('token', data['token_fks']);
  }

  public logout(){
      return this.storage.clear();
  }

  public getInfo(){
      return this.storage.get('userinfo');
  }

  public getSystemInfo(){
      return this.storage.get('sys');
  }

  public getTeam(){
      return this.storage.get('subsidiaryId');
  }

  public setTeam(val){
      return this.storage.set('team', val);
  }

  public clearData(){
      return this.storage.clear();
  }

}
